// extracted by mini-css-extract-plugin
module.exports = {"tenant-selector":"TenantSelector_tenant-selector__JZWJV","tenant-selector--manage-tenants-text":"TenantSelector_tenant-selector--manage-tenants-text__BMyW7"};